//状态转换
export function statusToZH(val, t = "是", n = "否") {
  switch (val) {
    case 1:
      return t;
      break;
    case "1":
      return t;
      break;
    case  true :
      return t;
      break;
    case  "true" :
      return t;
      break
    default:
      return n;
  }
}


let channelData = new Map
channelData.set("thyny", "淘宝")
channelData.set("tm", "天猫")
channelData.set("taote", "淘特")
channelData.set("c2m", "阿里巴巴C2M")
channelData.set("jingdong", "京东")
channelData.set("pinduoduo", "拼多多")
channelData.set("weixin", "微信")
channelData.set("kuajing", "跨境")
channelData.set("kuaishou", "快手")
channelData.set("youzan", "有赞")
channelData.set("douyin", "抖音")
channelData.set("siku", "寺库")
channelData.set("meituan", "美团团好货")
channelData.set("xiaohongshu", "小红书")
channelData.set("dangdang", "当当")
channelData.set("suning", "苏宁")
channelData.set("davdian", "大V店")
channelData.set("xingyun", "行云")
channelData.set("miya", "蜜芽")
channelData.set("boluo", "菠萝派商城")
channelData.set("kuaituantuan", "快团团")
channelData.set("other", "其他")


export const getChannel = (key) => {
  if (channelData.has(key)) {
    return channelData.get(key)
  }
  return ""
}
/**
 * 计件类型
 * @param key
 * @returns {string}
 */
export const expressTemplateChargeType = (key) => {
  switch (parseInt(key)) {
    case 0:
      return "重量";
    case 1:
      return "件数";
    case 2:
      return "体积";
  }

}

/**
 * 运费承担类型
 * @param key
 * @returns {string}
 */
export const expressTemplateServiceChargeType = (key) => {
  switch (parseInt(key)) {
    case 0:
      return "卖家承担";
    case 1:
      return "买家承担";

  }

}


/**
 * 服务类型
 * @param key
 * @returns {string}
 */
export const expressTemplateServiceType = (key) => {
  switch (parseInt(key)) {
    case 0:
      return "快递";
    case 1:
      return "货运";
    case 2:
      return "货到付款";
  }

}


/**
 * 子模板类型
 * @param key
 * @returns {string}
 */
export const expressTemplateSubType = (key) => {
  switch (parseInt(key)) {
    case 0:
      return "基准";
    case 1:
      return "增值";
  }

}
//订单状态，值有 success, cancel(交易取消，违约金等交割完毕), waitbuyerpay(等待卖家付款)， waitsellersend(等待卖家发货), waitbuyerreceive(等待买家收货 )
export const alibabaOrderStatusList = [
  {value: null, label: "全部"},
  {value: "success", label: "完成"},
  {value: "cancel", label: "交易取消"},
  {value: "waitbuyerpay", label: "等待买家付款"},
  {value: "waitsellersend", label: "等待卖家发货"},
  {value: "waitbuyerreceive", label: "等待买家收货"},
  {value: "confirm_goods_and_has_subsidy", label: "确认收货"}
]
export const alibabaOrderStatus = (value,all=true) => {
  for (let i = 0; i < alibabaOrderStatusList.length; i++) {
    if (alibabaOrderStatusList[i].value == value) {
      if (!all && value == null) {
        return
      }
      return alibabaOrderStatusList[i].label;
    }
  }
}
//退款状态，支持： "waitselleragree"(等待卖家同意), "refundsuccess"(退款成功),
// "refundclose"(退款关闭), "waitbuyermodify"(待买家修改),
// "waitbuyersend"(等待买家退货), "waitsellerreceive"(等待卖家确认收货)
export const alibabaOrderRefundStatusList = [
  {value: null, label: "全部"},
  {value: "waitselleragree", label: "等待卖家同意"},
  {value: "refundsuccess", label: "退款成功"},
  {value: "refundclose", label: "退款关闭"},
  {value: "waitbuyermodify", label: "待买家修改"},
  {value: "waitbuyersend", label: "等待买家退货"},
  {value: "waitsellerreceive", label: "等待卖家确认收货"},

]
export const alibabaOrderRefundStatus = (value, all = true) => {
  for (let i = 0; i < alibabaOrderRefundStatusList.length; i++) {
    if (alibabaOrderRefundStatusList[i].value == value) {
      if (!all && value == null) {
        return
      }
      return alibabaOrderRefundStatusList[i].label
    }
  }
}
/**
 * 1:担保交易 2:预存款交易 3:ETC境外收单交易 4:即时到帐交易
 * 5:保障金安全交易 6:统一交易流程 7:分阶段付款
 * 8.货到付款交易 9.信用凭证支付交易 10.账期支付交易，50060 交易4.0
 */
export const alibabaOrderTradeTypeList = [
  {value: null, label: "全部"},
  {value: "1", label: "担保交易"},
  {value: "2", label: "预存款交易"},
  {value: "3", label: "ETC境外收单交易"},
  {value: "4", label: "即时到帐交易"},
  {value: "5", label: "保障金安全交易"},
  {value: "6", label: "统一交易流程"},
  {value: "7", label: "分阶段付款"},
  {value: "8", label: "货到付款交易"},
  {value: "9", label: "信用凭证支付交易"},
  {value: "10", label: "账期支付交易"},
  {value: "50060", label: "交易4.0"},

]
export const alibabaOrderTradeType = (value) => {
  for (let i = 0; i < alibabaOrderTradeTypeList.length; i++) {
    if (alibabaOrderTradeTypeList[i].value == value) {
      return alibabaOrderTradeTypeList[i].label
    }
  }
}
/**
 * 1 未发货 2 已发货 3 已收货 4 已经退货 5 部分发货 8 还未创建物流订单
 * @type {[{label: string, value: null},{label: string, value: string},{label: string, value: string},{label: string, value: string},{label: string, value: string},null,null,null,null,null,null,null]}
 */
export const logisticsStatusList = [
  {value: null, label: "全部"},
  {value: 1, label: "未发货"},
  {value: 2, label: "已发货"},
  {value: 3, label: "已收货"},
  {value: 4, label: "已经退货"},
  {value: 5, label: "部分发货"},
  {value: 8, label: "还未创建物流订单"},
]

export const logisticsStatus = (value) => {
  for (let i = 0; i < logisticsStatusList.length; i++) {
    if (logisticsStatusList[i].value == value) {
      return logisticsStatusList[i].label
    }
  }
}

export const logisticsTypeList = [
  {value: "0", label: "自行发货"},
  {value: "1", label: "在线发货"},
  {value: "2", label: "不需要物流的发货"},
]
export const logisticsType = (value) => {
  for (let i = 0; i < logisticsTypeList.length; i++) {
    if (logisticsTypeList[i].value == value) {
      return logisticsTypeList[i].label
    }
  }
}
//
// 无需物流类别,noLogisticsCondition=1， 表示其他第三方物流、小型物充商、车队等,
// noLogisticsCondition=2 表示补运费、差价,
// noLogisticsCondition=3 表示卖家配送,
// noLogisticsCondition=4 表示买家自提
// noLogisticsCondition=5 表示其他原因

export const noLogisticsConditionList = [
  {value: null, label: "全部"},
  {value: 1, label: "其他第三方物流"},
  {value: 2, label: "补运费、差价"},
  {value: 3, label: "卖家配送"},
  {value: 4, label: "买家自提"},
  {value: 5, label: "其他原因"},

]

export const noLogisticsCondition = (value) => {
  for (let i = 0; i < noLogisticsConditionList.length; i++) {
    if (noLogisticsConditionList[i].value == value) {
      return noLogisticsConditionList[i].label
    }
  }
}
export const refundActionList = [
  {value: "BUYER_APPLY_REFUND", label: "买家申请退款"},
  {value: "BUYER_RECEIVE_CLOSE", label: "买家确认收货关闭"},
  {value: "SELLER_SEND_GOODS_CLOSE", label: "卖家发货关闭"},
  {value: "BUYER_CANCEL_REFUND_CLOSE", label: "买家撤销退款申请关闭"},
  {value: "BUYER_UPLOAD_BILL", label: "买家上传凭证"},
  {value: "SELLER_UPLOAD_BILL", label: "卖家上传凭证"},
  {value: "SELLER_REJECT_REFUND", label: "卖家拒绝退款"},
  {value: "SELLER_AGREE_REFUND", label: "卖家同意退款"},
  {value: "SELLER_RECEIVE_GOODS", label: "卖家确认收货"},
  {value: "BUYER_SEND_GOODS", label: "买家声明发货"},
  {value: "BUYER_MODIFY_REFUND_PROTOCOL", label: "买家修改退款协议"},
  {value: "BUYER_APPLY_SUPPORT", label: "买家申请客服介入"},
  {value: "SELLER_APPLY_SUPPORT", label: "卖家申请客服介入"},
  {value: "SYSTEM_AGREE_REFUND_PROTOCOL", label: "系统超时同意退款协议"},
  {value: "SYSTEM_AGREE_REFUND", label: "系统超时同意退款，即退款成功"},
  {value: "SYSTEM_SEND_GOODS", label: "系统超时退货，主交易流程的退货"},
  {value: "SYSTEM_MODIFY_REFUND_PROTOCOL", label: "系统超时修改协议"},
  {value: "SYSTEM_NOTIFY_APPLY_SUPPORT", label: "系统通知申请客服介入"},
  {value: "SELLER_AGREE_REFUND_PROCOTOL", label: "卖家同意退款协议"},
  {value: "SELLER_REJECT_REFUND_PROCOTOL", label: "卖家拒绝退款协议"},
  {value: "CRM_APPLY_TIMEOUT_CLOSE", label: "申请客服介入、超时关闭、目前仅售后业务在用"},
  {value: "CRM_APPLY_SUPPORT", label: "CRM申请介入"},
  {value: "CRM_INTERVENE_TASK", label: "CRM介入处理"},
  {value: "CRM_DISMISS_TASK", label: "CRM撤销工单"},
  {value: "CRM_FINISH_TASK", label: "CRM完结工单"},
  {value: "BUYER_STEP_PAY_ORDER_CLOSE", label: "买家支付，退款关闭，分阶段订单情况"},
  {value: "BUYER_STEP_CONFIRM_CLOSE", label: "买家确认，退款关闭，分阶段订单情况"},
  {value: "BUYER_CLOSE_TRADE_CLOSE", label: "买家终止交易，退款关闭，分阶段订单情况"},
  {value: "SELLER_CONFIRM_ORDER_CLOSE", label: "卖家确认，退款关闭，分阶段订单情况"},
  {value: "SELLER_STEP_PUSH_CLOSE", label: "卖家推进，退款关闭，分阶段订单情况"},
]

export const refundAction = (value, all = true) => {
  for (let i = 0; i < refundActionList.length; i++) {
    if (refundActionList[i].value == value) {

      return refundActionList[i].label
    }
  }
}
//支付状态
//国际站：WAIT_PAY(未支付),PAYER_PAID(已完成支付),PART_SUCCESS(部分支付成功),PAY_SUCCESS(支付成功),CLOSED(风控关闭),CANCELLED(支付撤销),SUCCESS(成功),FAIL(失败)。
// 1688:1(未付款);2(已付款);4(全额退款);6(卖家有收到钱，回款完成) ;7(未创建外部支付单);8 (付款前取消) ; 9(正在支付中);12(账期支付,待到账)
export const alibabaPayStatusList = [
  {value: "WAIT_PAY", label: "未支付"},
  {value: "PAYER_PAID", label: "已完成支付"},
  {value: "PART_SUCCESS", label: "部分支付成功"},
  {value: "PAY_SUCCESS", label: "支付成功"},
  {value: "CLOSED", label: "风控关闭"},
  {value: "CANCELLED", label: "支付撤销"},
  {value: "SUCCESS", label: "成功"},
  {value: "FAIL", label: "失败"},
  {value: "1", label: "未付款"},
  {value: "2", label: "已付款"},
  {value: "4", label: "全额退款"},
  {value: "6", label: "卖家有收到钱，回款完成"},
  {value: "7", label: "未创建外部支付单"},
  {value: "8", label: "付款前取消"},
  {value: "9", label: "正在支付中"},
  {value: "12", label: "账期支付,待到账"},
]
export const alibabaPayStatus = (value) => {
  for (let i = 0; i < alibabaPayStatusList.length; i++) {
    if (alibabaPayStatusList[i].value == value + "") {

      return alibabaPayStatusList[i].label
    }
  }
}
//支付方式。 国际站：ECL(融资支付),CC(信用卡),TT(线下TT),ACH(echecking支付)。
// 1688:1-支付宝,2-网商银行信任付,3-诚e赊,4-银行转账,5-赊销宝,6-电子承兑票据,7-账期支付,8-合并支付渠道,9-无打款,10-零售通赊购,13-支付平台,12-声明付款
export const alibabaPayWayList = [
  {value: "ECL", label: "融资支付"},
  {value: "CC", label: "信用卡"},
  {value: "TT", label: "线下TT"},
  {value: "ACH", label: "echecking支付"},
  {value: "1", label: "支付宝"},
  {value: "2", label: "网商银行信任付"},
  {value: "3", label: "诚e赊"},
  {value: "4", label: "银行转账"},
  {value: "5", label: "赊销宝"},
  {value: "6", label: "电子承兑票据"},
  {value: "7", label: "账期支付"},
  {value: "8", label: "合并支付渠道"},
  {value: "9", label: "无打款"},
  {value: "10", label: "零售通赊购"},
  {value: "13", label: "支付平台"},
  {value: "12", label: "声明付款"},
]
export const alibabaPayWay = (value) => {
  for (let i = 0; i < alibabaPayWayList.length; i++) {
    if (alibabaPayWayList[i].value == value + "") {
      return alibabaPayWayList[i].label
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/alibaba/config.js